import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Breadcrumb } from "react-bootstrap";
import { COLOR_APP } from "../../constants";

function HelpMessageSetting() {
    const { history } = useReactRouter()


    useEffect(() => {

    }, [])


    return (
        <div>
            MESSAGE_SETTING
        </div >
    );
}

export default HelpMessageSetting;